"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const hooks_1 = require("../../../../store/hooks");
const timelapseSelectors_1 = require("../../../../store/timelapseSelectors");
const timelapseSlice_1 = require("../../../../store/timelapseSlice");
const timelapse_1 = require("../../../../types/timelapse");
const S = __importStar(require("./TimelapseComponent.style"));
const TimeRangeButtons = () => {
    const timeRange = (0, hooks_1.useAppSelector)(timelapseSelectors_1.selectTimelapseTimeRange);
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, hooks_1.useAppDispatch)();
    const onSelectTimeRange = (timeRange) => {
        dispatch((0, timelapseSlice_1.setTimelapseTimeRange)(timeRange));
    };
    return (react_1.default.createElement(S.TimeRangeButtonsContainer, null,
        react_1.default.createElement(S.TimeRangeLabel, null, t("timelapse.timeRange.label")),
        react_1.default.createElement(S.TimeRangeButton, { "$isActive": timeRange === timelapse_1.TimeRanges.HOURS_24, onClick: () => onSelectTimeRange(timelapse_1.TimeRanges.HOURS_24) }, t("timelapse.timeRange.24hours")),
        react_1.default.createElement(S.TimeRangeButton, { "$isActive": timeRange === timelapse_1.TimeRanges.DAYS_3, onClick: () => onSelectTimeRange(timelapse_1.TimeRanges.DAYS_3) }, t("timelapse.timeRange.3days")),
        react_1.default.createElement(S.TimeRangeButton, { "$isActive": timeRange === timelapse_1.TimeRanges.DAYS_7, onClick: () => onSelectTimeRange(timelapse_1.TimeRanges.DAYS_7) }, t("timelapse.timeRange.7days"))));
};
exports.default = TimeRangeButtons;
